import React, { useState } from "react";
import VolumeMetricsModal from "./VolumeMetricsModal";

const IndexSections = () => {
  const [volumeMetricsModalStatus, setVolumeMetricsModalStatus] = useState(false);
  
  return (
    <>
     <div className="snX goldenBox" data-aos="fade-up" data-aos-delay="500" data-aos-duration="1000">
         <div className="d-flex justify-content-between gap-1 align-items-start">
             <div>
                 <h2>Volume metrics</h2>
                 <p>Track the real-time trading volume of UFO compared to the PulseX DEX volume. This chart illustrates how rising on-chain volume directly boosts the volume and value generation for The Grays.</p>
                 <button onClick={() => setVolumeMetricsModalStatus(true)} className="mybtn underline text-white p-0 mt-0"><span>View Now</span></button>
             </div>
             <div>
             </div>
         </div>
     </div>
     <VolumeMetricsModal modalIsOpen={volumeMetricsModalStatus} closeModal={() => setVolumeMetricsModalStatus(false)} />
    </>
  );
};

export default IndexSections;